import { useEffect, useState } from "react";
import styled from "styled-components";
import { formatDate, toNumber } from "../../types/types";
import { Image } from "../common/image";
import { formatDateString } from "../../API/AppRepository";

const Container = styled.div`
  width: 90vw;
  height: 127vw;
  align-items: center;
  background-color: white;
`;

const Wrapper = styled.div`
  width: 87vw;
  height: 127vw;
  margin: 0 auto;
  color: #000;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 10vw;
  margin-top: 2vw;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 23vw;
    height: auto;
  }

  h1 {
    font-size: 2.5vw;
    color: #ff4500;
    margin-left: 1vw;
  }
`;
const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
const Date = styled.div`
  font-size: 1.5vw;
  font-weight: 300;
`;
const ChargeTitle = styled.div`
  font-size: 4vw;
  font-weight: 700;
  margin-bottom: 1vw;
`;
const InfoTable = styled.table`
  width: 100%;
  /* outline: 1px solid red; */
  border-collapse: collapse;
  /* margin: 2vw 0; */
  table-layout: fixed;

  td {
    height: 2.6vw;
    border: 0.1vw solid #000;
    padding: 0.6vw;
    font-size: 1.6vw;
    text-align: start;
    word-wrap: break-word;
  }

  td:nth-child(2n + 1) {
    background-color: #f4f4f4;
    font-weight: bold;
    text-align: center;
  }
  td:not(:first-child) {
    border-left: 0.1vw dotted #000;
  }
`;

const SectionTitle = styled.h2`
  font-size: 1.7vw;
  margin-top: 1vw;
  font-weight: 600;
  /* border-bottom: 0.1vw solid #000; */
  padding-bottom: 0.5vw;
`;

const Section = styled.div`
  margin-bottom: 1vw;
`;

const ContentTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 1vw 0;
  table-layout: fixed;

  th,
  td {
    border: 0.1vw solid #000;
    padding: 0.4vw;
    text-align: center;
    font-size: 1.4vw;
    word-wrap: break-word;
  }

  tr:first-child {
    background-color: #f4f4f4;
    font-weight: bold;
  }
  tr:last-child {
    background-color: #f4f4f4;
    font-weight: bold;
  }
  th {
    background-color: #f4f4f4;
  }
`;

const TableCell = styled.td<{ width?: string; $align?: string }>`
  width: ${(props) => props.width};
  border: 0.1vw solid #000;
  height: 2.6vw;
  text-align: ${(props) => (props.$align ? props.$align : "center")}!important;
  font-size: 1.6vw;
`;

const TableCellTextBox = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TableCellText = styled.pre<{ width?: string; $align?: string }>`
  white-space: pre-line; /* width 안에서 받아온 엔터 그대로 적용 될 수 있도록 처리 / 넘치면 아래로 내려감 */
  border: 0.1vw dotted #000;
  text-align: ${(props) => (props.$align ? props.$align : "center")}!important;
  width: ${(props) => props.width};
  max-height: 10vw;
  font-size: 1.4vw;
  resize: none; /* 크기 조절 비활성화 */
  overflow: hidden;
  padding: 1vw;
`;

const DottedTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  td {
    border: 0.1vw dotted #767676;
    padding: 1.5vw;
    font-size: 1.2vw;
    text-align: start;
    height: 8vw;
  }

  td:first-child {
    width: 50%;
  }

  td:not(:first-child) {
    border-left: 0.1vw dotted #000;
  }
`;

const ScheduleTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 1vw;
  table-layout: fixed;

  td {
    border: 0.1vw dotted #000;
    padding: 1vw;
    font-size: 1.6vw;
    word-wrap: break-word;
    text-align: center; /* 수평 중앙 정렬 */
    vertical-align: middle; /* 수직 중앙 정렬 */
  }

  .schedule-header {
    background-color: #f0f0f0; /* 예시 배경색 */
    font-weight: bold;
    text-align: center; /* 수평 중앙 정렬 */
    vertical-align: middle; /* 수직 중앙 정렬 */
  }

  .schedule-cell {
    background-color: #ffffff; /* 예시 배경색 */
    font-weight: 300;
    text-align: start; /* 수평 중앙 정렬 */
    vertical-align: middle; /* 수직 중앙 정렬 */
    font-size: 1.6vw;
    height: 3vw;
  }

  .additional-condition {
    background-color: #fffde7; /* 예시 배경색 */
    font-weight: bold;
    text-align: center; /* 수평 중앙 정렬 */
    vertical-align: middle; /* 수직 중앙 정렬 */
  }

  .payment-info {
    background-color: #fce4ec; /* 예시 배경색 */
    font-weight: normal;
    text-align: center; /* 수평 중앙 정렬 */
    vertical-align: middle; /* 수직 중앙 정렬 */
  }
`;

const Footer = styled.div`
  text-align: center;
  margin-top: 3vw;
`;

const QuotationText = styled.p`
  font-size: 2.8vw;
  line-height: 1.5vw;
  font-weight: bold;
  margin-bottom: 1vw;
`;

const EnglishText = styled.p`
  font-size: 1.2vw;
`;

const StampArea = styled.div`
  margin-top: 1vw;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 5vw;
`;

const ComponyNameTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.2vw;
  font-weight: 700;
`;

function ChargeExportFirstPage(props: any) {
  const { contractInfo, chargeList } = props;

  const [totalAmount, setTotalAmount] = useState("");

  useEffect(() => {
    let total = 0;
    chargeList.forEach((item: any) => {
      total += toNumber(item.quotedPrice);
    });
    setTotalAmount(total.toLocaleString());
  }, []);

  return (
    <Container className={`companyContractPage1`}>
      <Wrapper>
        <Header>
          <Logo>
            {/* <TonginLogoIcon height={"8vw"}></TonginLogoIcon> */}
            <img src="/icon/tonginLogo.png" alt="Logo" />
            {/* <h1>통인익스프레스</h1> */}
          </Logo>
          <DateContainer>
            <ChargeTitle>견적서</ChargeTitle>
            <Date>
              DATE : {formatDate(contractInfo.detailInfo.contractDate)}
            </Date>
          </DateContainer>
        </Header>

        <InfoTable>
          <tbody>
            <tr>
              <td>수신</td>
              <td colSpan={3}>{contractInfo.clientInfo.companyName}</td>
              <td>발신</td>
              <td colSpan={3}>{contractInfo.headInfo.companyName}</td>
            </tr>

            <tr>
              <td>담당자</td>
              <td colSpan={3}>{contractInfo.clientInfo.contactPerson}</td>
              <td>담당자</td>
              <td colSpan={3}>{contractInfo.headInfo.contactPerson}</td>
            </tr>
            <tr>
              <td>TEL</td>
              <td colSpan={3}>{contractInfo.clientInfo.contactNumber}</td>
              <td>TEL</td>
              <td colSpan={3}>{contractInfo.headInfo.contactNumber}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td colSpan={3}>{contractInfo.clientInfo.email}</td>
              <td>Email</td>
              <td colSpan={3}>{contractInfo.headInfo.email}</td>
            </tr>
          </tbody>
        </InfoTable>

        <Section>
          <SectionTitle>1. 제목: {contractInfo.detailInfo.title}</SectionTitle>
        </Section>

        <Section>
          <SectionTitle>2. 내용</SectionTitle>
          <ContentTable>
            <tbody>
              <tr>
                <TableCell width="20vw">품명</TableCell>
                <TableCell width="16vw">작업구분</TableCell>
                <TableCell width="20vw">작업내용</TableCell>
                <TableCell width="20vw">금액(원)</TableCell>
                <TableCell width="8vw">비고</TableCell>
              </tr>
              {chargeList.map((item: any) => {
                return (
                  <tr key={item.id}>
                    <TableCell width="20vw">{item.name}</TableCell>
                    <TableCell width="20vw">{item.category}</TableCell>
                    <TableCell width="20vw">{item.contents}</TableCell>
                    <TableCell width="20vw" $align="end">
                      {item.quotedPrice}
                    </TableCell>
                    <TableCell width="6.8vw">{item.remark}</TableCell>
                  </tr>
                );
              })}
              <tr>
                <TableCell colSpan={3}>합계</TableCell>
                <TableCell $align="end">{totalAmount}</TableCell>
                <TableCell>VAT별도</TableCell>
              </tr>
            </tbody>
          </ContentTable>
        </Section>

        <Section>
          <SectionTitle>3. 상세 작업 내역</SectionTitle>

          <TableCellTextBox>
            <TableCellText $align="left" width="49.4%">
              {contractInfo.detailInfo.workCondition1}
            </TableCellText>
            <TableCellText $align="left" width="49.4%">
              {contractInfo.detailInfo.workCondition2}
            </TableCellText>
          </TableCellTextBox>
        </Section>

        <Section>
          <SectionTitle>4. 작업 일정 및 조건</SectionTitle>
          <ScheduleTable>
            <tbody>
              <tr className="schedule-header">
                <td rowSpan={2}>작업 일정</td>
                <td colSpan={8} className="schedule-cell">
                  {formatDateString(contractInfo.detailInfo.workDate1)}
                </td>
              </tr>
              <tr>
                <td colSpan={8} className="schedule-cell">
                  {formatDateString(contractInfo.detailInfo.workDate2)}
                </td>
              </tr>
              <tr className="schedule-header">
                <td rowSpan={2}>작업주소1</td>
                <td colSpan={8} className="schedule-cell">
                  출발 : {contractInfo.detailInfo.departureAddress1} (
                  {contractInfo.detailInfo.departureZipCode1}) ,{" "}
                  {contractInfo.detailInfo.departureAddress1Detail}
                </td>
              </tr>
              <tr>
                <td colSpan={8} className="schedule-cell">
                  도착 : {contractInfo.detailInfo.destinationAddress1} (
                  {contractInfo.detailInfo.destinationZipCode1}) ,{" "}
                  {contractInfo.detailInfo.destinationAddress1Detail}
                </td>
              </tr>
              {contractInfo.detailInfo.departureAddress2 !== "" && (
                <>
                  <tr className="schedule-header">
                    <td rowSpan={2}>작업주소2</td>
                    <td colSpan={8} className="schedule-cell">
                      출발 : {contractInfo.detailInfo.departureAddress2} (
                      {contractInfo.detailInfo.departureZipCode2}) ,{" "}
                      {contractInfo.detailInfo.departureAddress2Detail}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={8} className="schedule-cell">
                      도착 : {contractInfo.detailInfo.destinationAddress2} (
                      {contractInfo.detailInfo.destinationZipCode2}) ,{" "}
                      {contractInfo.detailInfo.destinationAddress2Detail}
                    </td>
                  </tr>
                </>
              )}

              {contractInfo.detailInfo.departureAddress3 !== "" && (
                <>
                  <tr className="schedule-header">
                    <td rowSpan={2}>작업주소3</td>
                    <td colSpan={8} className="schedule-cell">
                      출발 : {contractInfo.detailInfo.departureAddress3} (
                      {contractInfo.detailInfo.departureZipCode3}) ,{" "}
                      {contractInfo.detailInfo.departureAddress3Detail}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={8} className="schedule-cell">
                      도착 : {contractInfo.detailInfo.destinationAddress3} (
                      {contractInfo.detailInfo.destinationZipCode3}) ,{" "}
                      {contractInfo.detailInfo.destinationAddress3Detail}
                    </td>
                  </tr>
                </>
              )}
              <tr className="schedule-header">
                <td rowSpan={1}>부대조건</td>
                <td colSpan={8} className="schedule-cell">
                  {contractInfo.detailInfo.subCondition}
                </td>
              </tr>
              <tr className="schedule-header">
                <td>불임</td>
                <td colSpan={8} className="schedule-cell">
                  견적서 외 용역비 산출내역서 {chargeList.length}장
                </td>
              </tr>
            </tbody>
          </ScheduleTable>
        </Section>

        <Footer>
          <QuotationText>상기와 같이 견적을 제시합니다.</QuotationText>
          <EnglishText>We hereby submit Quotation as above.</EnglishText>
          <StampArea>
            <ComponyNameTitle>주식회사 통인익스프레스</ComponyNameTitle>
            <Image src="/img/stamp.png" width={"5vw"} height={"5vw"}></Image>
          </StampArea>
        </Footer>
      </Wrapper>
    </Container>
  );
}

export default ChargeExportFirstPage;
